import api from './client'

/** Avisos — mensajería interna anclada a documentos. */
export const avisosApi = {
  crear: (data) => api.post('/avisos', data),
  mios: () => api.get('/avisos/mios'),
  destinatarios: () => api.get('/avisos/destinatarios'),
  porEntidad: (tipo, id) => api.get(`/avisos/entidad/${tipo}/${id}`),
  marcarLeido: (id) => api.post(`/avisos/${id}/leido`),
  resolver: (id) => api.post(`/avisos/${id}/resolver`),
}
